import { FC } from 'react';
import { ProductInfoTypeProps } from './TypeProps';
import { LabelDiscount } from '@app/shared';
import { MyLink } from '@ui-kit/MyLink';
import ClassNames from 'classnames';

import styles from './ProductInfo.module.scss';

export const ProductInfo: FC<ProductInfoTypeProps> = props => {
  const { name, url, description, price, specPrice, className } = props;
  return (
    <div className={ClassNames(styles.Container, className)}>
      <MyLink color={'black'} href={url || ''}>
        <div className={styles.Title}>{name}</div>
      </MyLink>
      <div className={styles.Info}>{description}</div>
      <LabelDiscount newPrice={specPrice} oldPrice={price} />
    </div>
  );
};
